import { useState } from "react";
import { Location } from "react-router-dom";
import { UserProfile } from "@/types/user";
import { ChatPreview, ChatType, ChatMessage } from "../types";
import { useChatInitialization } from "./useChatInitialization";
import { useChatActions } from "./useChatActions";
import { useCreateChat } from "./useCreateChat";
import { ChatStateReturn } from "../types";

export function useChatState(
  user: UserProfile | null,
  location: Location
): ChatStateReturn {
  // State for chat data
  const [chatPreviews, setChatPreviews] = useState<ChatPreview[]>([]);
  const [selectedChatId, setSelectedChatId] = useState<string | undefined>();
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [recipient, setRecipient] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  // Get chat actions (select, send, profile pic change)
  const { handleSelectChat, handleSendMessage, handleProfilePicChange } =
    useChatActions(
      user,
      chatPreviews,
      setChatPreviews,
      setMessages,
      setRecipient,
      selectedChatId,
      setSelectedChatId
    );

  // Get chat creation functions (group chat, new chat)
  const { handleCreateGroupChat, handleCreateNewChat } = useCreateChat(
    user,
    chatPreviews,
    setChatPreviews,
    setSelectedChatId,
    setRecipient,
    setMessages
  );

  // Initialize chat data
  useChatInitialization(
    user,
    location,
    handleSelectChat,
    setMessages,
    setChatPreviews,
    setRecipient,
    setLoading
  );

  return {
    chatPreviews,
    selectedChatId,
    loading,
    recipient,
    messages,
    handleSelectChat,
    handleSendMessage,
    handleProfilePicChange,
    handleCreateGroupChat,
    handleCreateNewChat,
  };
}
